import { getServerUrl } from "../../runtime-config.js";

export const URL = getServerUrl();

export let blId = null;
export let socket = null;
export let vm = null;
export let store = null;

export const setBlId = (id) => {
    blId = id;
};
export const setSocket = (s) => {
    socket = s;
};
export const setVm = (v) => {
    vm = v;
};
export const setStore = (s) => {
    store = s;
};
